"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // This file determines the top-level package exports

var main_1 = require("./main");

exports.addTask = main_1.addTask;
exports.run = main_1.run;
exports.baseUrl = main_1.baseUrl;

var fetch_1 = require("./fetch");

exports.fetch = fetch_1.fetch;